export const pt = {
  installmentSelectItem: 'Em até {{installments}}x',
  errors: {
    general: 'Erro inesperado. Tente novamente.',
  },
  backendErrors: {
    'validator--invalid-field': 'Verifique os campos do formulário.',
  },
  fieldErrors: {
    required: 'Campo obrigatório',
    min: 'Valor mínimo é 10 reais',
    url: 'URL inválida',
    youtubeEmbedUrl: 'URL do YouTube inválida',
    positive: 'Valor deve ser um número positivo',
    differentFromUpsellUrl: 'Não utilize links de upsell de 1-clique!',
    minOldTotal: 'Valor mínimo é 10 reais',
    isLessPrice: 'O preço promocional deve ser menor que o preço',
    isNumber: 'O preço promocional deve ser um número',
    isGreaterFiveSeconds: 'O tempo do cronômetro deve ser maior que 5 segundos',
  },
  closeAlertModal: {
    title: 'Alterações não salvas',
    description: 'As alterações realizadas não foram salvas. Deseja sair mesmo assim?',
    stay: 'Ficar na página',
    leave: 'Sair',
  },
  closePromptAlert: 'As alterações realizadas não foram salvas. Deseja sair mesmo assim?',
  plans: {
    monthly: 'Mensal',
    quarterly: 'Trimestral',
    semiannually: 'Semestral',
    annually: 'Anual',
  },
  plansPerPeriod: {
    monthly: 'mês',
    quarterly: 'trimestre',
    semiannually: 'semestre',
    annually: 'ano',
  },
  paymentMethod: {
    credit_card: 'Cartão de crédito',
    bank_slip: 'Boleto',
    pix: 'PIX',
  },
  priceType: {
    oneTime: 'pagamento único',
    recurring: 'assinatura recorrente',
  },
  offer: {
    name: {
      label: 'Nome',
      placeholder: 'Digite o nome da oferta',
    },
    header: {
      back: 'Voltar',
      draft: 'Salvar rascunho',
      publish: 'Criar oferta',
      edit: 'Atualizar oferta',
    },
    tooltipErrors: {
      pricing: 'Preço',
      checkout: 'Checkout',
      afterPurchase: 'Pós-compra',
      name: 'Nome',
      cohortId: 'Turma',
    },
    title: {
      edit: 'Editar oferta',
      new: 'Nova oferta',
    },
    tabs: {
      pricing: 'Preço',
      checkout: 'Checkout',
      afterPurchase: 'Pós-compra',
      pricingEvent: 'Preço',
      checkoutEvent: 'Checkout',
      afterPurchaseEvent: 'Pós-compra',
    },
    cohort: {
      title: 'Turma',
      select: {
        label: 'Turma',
        placeholder: 'Selecione a(s) turma(s)',
      },
    },
    cohortEvent: {
      title: 'Ingresso',
      select: {
        label: 'Ingresso',
        placeholder: 'Selecione o ingresso',
      },
    },
    pricingTab: {
      pricing: {
        title: 'Preço',
        subscriptionType: {
          oneTime: 'Pagamento único',
          recurring: 'Assinatura recorrente',
        },
        currency: {
          label: 'Moeda',
          description: 'Compras em outras moedas serão convertidas de acordo com o câmbio do dia. <0>Saiba mais</0>',
        },
        automationSettings: {
          title: 'Configurar automação avançada',
          disabled: {
            title: 'Inicie a automação',
            label: 'Agendar desativação da renovação automática',
            placeholder: 'Desativar após {{installment}} cobranças',
          },
          credits: {
            title: 'Depois, faça a seguinte ação:',
            label: 'Adicionar créditos/dias de acesso',
          },
        },
        price: {
          label: 'Preço',
        },
        promotion: {
          label: 'Preço promocional',
        },
        plan: {
          label: 'Plano',
        },
        installments: {
          label: 'Opções de parcelamento',
        },
        accessDays: {
          label: 'Tempo de acesso ao produto',
        },
        addPlan: 'Adicionar plano',
      },
      options: {
        title: 'Opções',

        membershipFee: {
          title: 'Cobrar taxa de adesão',
          description: 'Cobre uma taxa diferenciada de seus membros para o primeiro mês de acesso ao produto.',
          total: 'Taxa de adesão',
          installments: 'Opções de parcelamento',
        },
        smartInstallments: {
          title: 'Recuperação de vendas via parcelamento inteligente',
          description:
            'Se o cartão do cliente falhar por falta de limite, tentamos concluir a compra cobrando uma parcela. O restante será parcelado automaticamente em mensalidades.',
          warning: 'Vendas com parcelamento inteligente serão marcadas com este ícone na fatura.',
          maxInstallments: 'Número máximo de parcelas',
          installmentsWithoutDebt: {
            label: 'Parcelas sem dívida',
            description:
              'O cliente não acumulará dívida. O acesso será suspenso temporariamente e liberado ao pagar uma parcela atrasada.',
          },
          installmentsWithDebt: {
            label: 'Parcelas com dívida',
            description:
              'O cliente acumulará dívidas se atrasar parcelas. O acesso será bloqueado até que todas as parcelas atrasadas sejam pagas.',
          },
        },
        affiliatesSwitch: 'Disponibilizar essa oferta para afiliados',
        installmentCostsPayerSwitch: 'Absorver custos de parcelamento',
        installmentCostsPayerSwitchTooltip:
          'Ao optar por absorver os custos de parcelamento, você será responsável por pagar os juros cobrados pela bandeira do cartão de crédito. Caso contrário, o cliente terá esse custo acrescentado em suas parcelas, de acordo com a opção escolhida.',
      },
    },
    checkoutTab: {
      preferences: {
        title: 'Preferências',
        theme: {
          label: 'Modo claro/escuro',
          light: 'Modo claro',
          dark: 'Modo escuro',
        },
        layout: {
          label: 'Template',
          no_banner: 'Checkout simples',
          top_and_bottom_banner: 'Checkout com banner e rodapé',
          full_banner: 'Checkout com banner, imagem lateral e rodapé',
        },
        priceFormat: {
          label: 'Formato do preço',
          full: 'Valor parcelado (ex.: 12x de R$ 25,00)',
          partial: 'Valor cheio (ex.: R$ 300,00)',
        },
        purchaseExperience: {
          label: 'Experiência de compra',
          oneStep: 'Em uma única etapa',
          twoStep: 'Em duas etapas',
        },
        colorPicker: 'Cor de fundo',
      },
      customization: {
        title: 'Personalização',
        appearence: {
          title: 'Aparência',
          bgColor: 'Cor de fundo',
          cta: {
            label: 'Personalizar botão de compra',
            text: 'Texto do botão',
            bgColor: 'Cor do botão',
            textColor: 'Cor do texto do botão',
          },
        },
        logo: {
          label: 'Logo do criador',
          description: 'JPEG, PNG, GIF ou SVG acima de 300x300 pixels',
          position: 'Posição do logo',
          left: 'Alinhado a esquerda',
          center: 'Alinhado ao centro',
        },
        banner: {
          title: 'Banner',
          size: {
            label: 'Tamanho do banner',
            small: 'Pequeno',
            medium: 'Médio',
            large: 'Grande',
          },
          layout: {
            label: 'Layout',
            full: 'Tela cheia',
            fitContent: 'Ajuste ao conteúdo',
          },
          mobile: {
            label: 'Banner mobile',
            description: 'JPEG, PNG, GIF ou SVG, {{size}}',
          },
          desktop: {
            label: 'Banner desktop',
            description: 'JPEG, PNG, GIF ou SVG, {{size}}',
          },
        },
        sideBanner: {
          title: 'Imagem lateral',
          mobile: {
            label: 'Imagem lateral mobile',
            description: 'JPEG, PNG, GIF ou SVG, nas dimensões 420px x 794px',
          },
          desktop: {
            label: 'Imagem lateral desktop',
            description: 'JPEG, PNG, GIF ou SVG, nas dimensões 340px x 960px',
          },
        },
        guaranteeSeal: {
          title: 'Selo de garantia',
          mobile: {
            label: 'Selo de garantia mobile',
            description: 'JPEG, PNG, GIF ou SVG, nas dimensões 420px x 145px',
          },
          desktop: {
            label: 'Selo de garantia desktop',
            description: 'JPEG, PNG, GIF ou SVG, nas dimensões 580px x 145px',
          },
        },
        footerBanner: {
          title: 'Imagem de rodapé',
          size: {
            label: 'Tamanho do rodapé',
            small: 'Pequeno',
            medium: 'Médio',
            large: 'Grande',
          },
          mobile: {
            label: 'Imagem de rodapé mobile',
            description: 'JPEG, PNG, GIF ou SVG, nas dimensões 420px x 250px',
          },
          desktop: {
            label: 'Imagem de rodapé desktop',
            description: 'JPEG, PNG, GIF ou SVG, nas dimensões 580px x 250px',
          },
        },
        bannerMobile: {
          label: 'Banner mobile',
          description: 'JPEG, PNG, GIF ou SVG acima de 1440x1024 pixels',
        },
        bannerDesktop: {
          label: 'Banner desktop',
          description: 'JPEG, PNG, GIF ou SVG acima de 1900x600 pixels',
        },
        preferences: {
          title: 'Preferências',
          planPreselected: 'Plano pré-selecionado',
          installmentPreselected: 'Parcelamento pré-selecionado',
          priceFormat: 'Formato de preço no checkout',
        },
      },
      paymentMethods: {
        title: 'Métodos de pagamento',
        disabledWarn: 'Não é possível desabilitar todos os métodos de pagamento da sua oferta.',
        priceTypeNotAllowed:
          'Não é possível utilizar o método de pagamento {{paymentMethod}} para ofertas de assinatura {{priceType}}.',
      },
      options: {
        title: 'Opções',
        orderBump: {
          title: 'Adicionar oferta de orderbump',
          description: 'Oferte um novo produto complementar durante o momento da compra do seu produto.',
          add: 'Adicionar order bump',
          edit: 'Salvar',
          close: 'Fechar',
          cancel: 'Cancelar',
        },
        defaultOptions: {
          title: 'Configurar opções pré-selecionadas',
        },
        timer: {
          title: 'Adicionar cronômetro de contagem regressiva',
          timerSeconds: 'Tempo do cronômetro',
          timerColor: 'Cor de fundo do cronômetro',
        },
        youtubeEmbed: {
          title: 'Adicionar vídeo do YouTube',
          description:
            'Adicionar um vídeo pode aumentar significativamente a conversão da sua oferta, além de mostrar mais credibilidade.',
          youtubeEmbedUrl: 'URL do vídeo do YouTube',
        },
        showCouponField: { title: 'Ocultar campo de cupom de desconto' },
        billingAddress: { title: 'Coletar endereço de cobrança dos clientes' },
        creatorSupport: {
          title: 'Adicionar botão de suporte personalizado',
          description: 'Adicione o link de direcionamento para acesso do cliente ao seu suporte.',
          creatorSupportUrl: 'Link de suporte',
        },
        termsUrl: {
          title: 'Adicionar link de termos de uso personalizado',
          description: 'Adicione o link de direcionamento para acesso do cliente ao seus termos de uso personalizado.',
          termsUrl: 'Link de direcionamento',
        },
      },
    },
    afterPurchaseTab: {
      title: 'Depois da compra, direcionar o cliente para',
      userGroups: {
        label: 'Minhas compras',
      },
      membersArea: {
        label: 'Área de membros do produto',
      },
      externalUrl: {
        label: 'Página externa',
        example: 'https://upsell.com.br',
        tip: 'Copie e cole o link de compra de 1-clique na sua página externa para ofertar o upsell do produto desejado. Esse link se encontra na aba ”Links” dentro dos seus produtos na plataforma.',
      },
      upsell: {
        label: 'Upsell de 1-clique na Hubla',
        add: 'Adicionar upsell',
        upsellRedirectType: {
          description: 'Depois do Upsell de 1-clique, direcionar o cliente para:',
          label: 'Direcionar para',
        },
      },
    },
  },
  redirectType: {
    user_groups: 'Minhas compras',
    members_area: 'Área de membros',
    external_url: 'Página de obrigado externa',
    upsell: 'Upsell de 1-clique na Hubla',
  },
  upsellModal: {
    title: 'Configurar upsell',
    description:
      'Selecione um novo produto que será ofertado como um upsell de 1-clique logo após a compra do seu cliente.',
    productList: {
      title: 'Produto',
      empty: 'Nenhum produto disponível',
      emptyAvailable: 'Nenhum produto disponível',
    },
    offersList: {
      title: 'Oferta',
      empty: 'Nenhuma oferta selecionada',
      emptyAvailable: 'Nenhuma oferta disponível',
    },
    youtubeEmbed: {
      title: 'Personalizar oferta com um vídeo do YouTube',
      description:
        'Adicionar um vídeo pode aumentar significativamente a conversão da sua oferta, além de mostrar mais credibilidade.',
      youtubeEmbedUrl: 'URL do vídeo do YouTube',
    },
    actions: {
      cancel: 'Cancelar',
      close: 'Fechar',
      save: 'Adicionar upsell',
      edit: 'Salvar upsell',
    },
  },
  orderBumpModal: {
    title: 'Adicionar orderbump',
    description: 'Configure uma oferta adicional que será exibida durante o checkout',
    productsList: {
      title: 'Escolha um produto',
      empty: 'Nenhum produto disponível',
      emptyAvailable: 'Nenhum produto disponível',
    },
    offersList: {
      title: 'Oferta',
      empty: 'Nenhuma oferta selecionado',
      emptyAvailable: 'Nenhuma oferta disponível',
    },
    options: {
      customTag: {
        title: 'Adicionar uma tag personalizada',
        label: 'Tag personalizada',
      },
      oldTotal: {
        title: 'Mostrar como um preço promocional',
        label: 'De',
        example: 'por {{price}} / {{interval}}',
      },
      description: {
        title: 'Adicionar uma descrição da oferta',
        label: 'Descrição da oferta',
      },
    },
    actions: {
      cancel: 'Cancelar',
      save: 'Adicionar',
    },
  },
  accessDays: {
    oneDay: '1 dia',
    oneMonth: '1 mês',
    threeMonths: '3 meses',
    sixMonths: '6 meses',
    nineMonths: '9 meses',
    oneYear: '1 ano',
    twoYears: '2 anos',
    threeYears: '3 anos',
    fourYears: '4 anos',
    fiveYears: '5 anos',
    indefinite: 'Indeterminado',
  },
  checkoutSettings: {
    view: {
      mobile: 'Mobile',
      desktop: 'Desktop',
    },
    timerText: 'Compre em até {{timer}} para não perder essa oferta',
  },
}
